module.exports = __webpack_public_path__ + "static/media/feature_3.79f0721e.jpg";